import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { Typography } from 'antd';
import styled from 'styled-components';
var TypographyTitle = styled(Typography.Title).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['block'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-typography {\n    color: ", ";\n    margin: 0;\n    display: ", ";\n    font-weight: bold;\n    text-align: ", ";\n  }\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.block ? 'block' : 'inline';
}, function (props) {
  return props.align;
});
var TypographyText = styled(Typography.Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['block', 'fontSize'].includes(prop);
  }
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.ant-typography {\n    color: ", ";\n    margin: 0;\n    display: ", ";\n    font-size: ", ";\n    text-align: ", ";\n\n    strong {\n      font-weight: bold;\n    }\n  }\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.block ? 'block' : 'inline';
}, function (props) {
  return props.fontSize && props.theme.fontSizes[props.fontSize] ? props.theme.fontSizes[props.fontSize] : props.fontSize;
}, function (props) {
  return props.align;
});
Typography.Title = TypographyTitle;
Typography.Text = TypographyText;
export default Typography;